import {useAppSelector} from 'store/hooks';
import type {EditMode} from '../types';
import {selectMetadataEditEditModes} from '../metadataEditSlice';

export const useEditMode = (
  id: string,
  key: string,
  defaultValue: EditMode,
): EditMode => {
  const status =
    useAppSelector(selectMetadataEditEditModes)?.[id]?.[key] ?? defaultValue;
  return status;
};
